export default __webpack_public_path__ + "static/media/underconstruction.6cb0aed2.png";